/**
 * @overview AvatarGrid component
 */

import cx from 'classnames';
import React from 'react';
import { getUniqueKey } from '../../_utils';
import { Avatar, AvatarProps } from '../avatar';
import styles from './avatar-grid.module.scss';

type AvatarItem = Pick<AvatarProps, 'name' | 'src'>;
export interface AvatarGridProps {
  /**
   *  List of avatar name and src.
   */
  items?: AvatarItem[];

  /**
   * unique id
   */
  id?: string;

  /**
   * Avatar grid container class name
   */
  className?: string;
}

export const AvatarGrid: React.FC<AvatarGridProps> = ({
  id,
  className,
  items = [],
  ...restProps
}: AvatarGridProps) =>
  items.length ? (
    <div className={cx(styles.container, className)} {...restProps} id={id}>
      {items.map((item: AvatarItem) => (
        <Avatar
          key={getUniqueKey(item)}
          name={item.name}
          src={item.src}
          size="l"
          showName
          namePosition="bottom"
          className={styles.avatarGroupItem}
        />
      ))}
    </div>
  ) : null;
